module.exports = __webpack_public_path__ + "img/meter-plus.8501eac0.svg";